import React, { useEffect } from 'react';
import ModalSubmitIcon from '../icon/ModalSubmitIcon';
import { useSelector } from 'react-redux';
import lang from '../../lang/lang.json';
import './modalsubmit.scss';

const ModalSubmit = ({ id, isSubmit, setIsSubmit }) => {
  const { language } = useSelector((state) => state.language);

  const handleClick = () => {
    setIsSubmit(false);
  };

  useEffect(() => {
    const handleClick = (e) => {
      if (!e.target.closest('#SelectDropdown-' + id)) {
      }
    };

    window.addEventListener('click', handleClick);
    return () => window.removeEventListener('click', handleClick);
  }, [id]);

  return (
    <div id={id} onClick={(e) => handleClick(e)} className="modal-background">
      <div className="modal-submit">
        <div className="modal-submit-icon">
          <ModalSubmitIcon />
        </div>
        <div className="modal-submit-div">
          <span className="modal-submit-header">
            {lang.MODAL_SUBMIT_TITLE[language]}
          </span>
          <div className="modal-submit-text">
            {lang.MODAL_SUBMIT_TEXT[language]}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalSubmit;
